// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603101407/js/" + chunkId + "." + {"44":"800df14d","225":"5dedc488","481":"9e3ff117","486":"0104a6c2","770":"f1a04684"}[chunkId] + ".0.8913332145833659.chunk.js";
};